module.exports = __webpack_public_path__ + "static/media/volunteers.5651e168.svg";